import { render } from "./ComoComp.vue?vue&type=template&id=057c6825&scoped=true"
import script from "./ComoComp.vue?vue&type=script&lang=js"
export * from "./ComoComp.vue?vue&type=script&lang=js"

import "./ComoComp.vue?vue&type=style&index=0&id=057c6825&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057c6825"]])

export default __exports__